import styled from "styled-components";

import { Panel } from "@src/modules/shared/components/Panel/components";

export const DicomViewerWrapper = styled(Panel)`
  overflow: hidden;
`;
